import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import DiagnosticsStore from "@/features/diagnostics/store/diagnostics-store.ts";
import {
    calculateSmartNumber,
    diffSmartNumberMapping,
} from "@/features/diagnostics/utils/diff-smart-number-mapping.ts";
import {
    smartNumberChangeMappingAction,
    smartNumberChangeMultipleColoursAction,
    smartNumberChangeMultipleMappingAction,
    smartNumberOverrideMappingAction,
    smartNumberSetMappingAction,
} from "@/redux/slices/smart-number-slice.ts";
import type { AppDispatch, RootState } from "@/redux/store.ts";

const smartNumberDiagnosticsMiddleware = createListenerMiddleware();

smartNumberDiagnosticsMiddleware.startListening.withTypes<RootState, AppDispatch>()({
    matcher: isAnyOf(
        smartNumberSetMappingAction,
        smartNumberOverrideMappingAction,
        smartNumberChangeMappingAction,
        smartNumberChangeMultipleMappingAction,
        smartNumberChangeMultipleColoursAction,
    ),
    effect: (action, listenerApi) => {
        const prevState = listenerApi.getOriginalState().smartNumber;
        const nextState = listenerApi.getState().smartNumber;

        const { description } = nextState;
        const prevMapping = prevState.mapping;
        const nextMapping = nextState.mapping;

        if (!nextMapping || description.length === 0) return;

        const changes = diffSmartNumberMapping(prevMapping, nextMapping, description);
        if (changes.length === 0) return;

        const smartNumberFrom = prevMapping ? calculateSmartNumber(prevMapping, description) : "";
        const smartNumberTo = calculateSmartNumber(nextMapping, description);

        DiagnosticsStore.collectSmartNumberChange({
            trigger: action.type,
            smartNumberFrom,
            smartNumberTo,
            changes,
        });
    },
});

export default smartNumberDiagnosticsMiddleware.middleware;
